import { css } from "@mui/material";

export const globalStyles = css`
    .notistack-SnackbarContainer {
        position: fixed;
        left: 8px;
        bottom: 8px;
    }
`;
